import React from 'react';

const makeMarkdownComponents = (theme) => {
  const textClass = theme?.text || 'text-gray-700';
  const linkClass = theme?.link || 'text-blue-600 hover:underline';

  return {
    p: ({ children }) => <p className={`mb-2 text-sm ${textClass}`}>{children}</p>,
    strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
    em: ({ children }) => <em className="italic">{children}</em>,
    ul: ({ children }) => <ul className={`list-disc list-inside mb-2 text-sm ${textClass}`}>{children}</ul>,
    ol: ({ children }) => <ol className={`list-decimal list-inside mb-2 text-sm ${textClass}`}>{children}</ol>,
    li: ({ children }) => <li className="ml-2">{children}</li>,
    h1: ({ children }) => <h1 className="text-lg font-bold mb-1">{children}</h1>,
    h2: ({ children }) => <h2 className="text-base font-bold mb-1">{children}</h2>,
    h3: ({ children }) => <h3 className="text-sm font-bold mb-1">{children}</h3>,
    a: ({ href, children }) => (
      <a
        href={href}
        className={`${linkClass} hover:underline`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    ),
  };
};

export default makeMarkdownComponents;
